import { Col, Empty, Input } from "antd";
import React from "react";
import { toCurrency } from "../../../common/utils/util";
import { BUS_OWN } from "../../utils/consts";
import ViewSurveyCard from "./ViewSurveyCard";

class BusinessView extends React.Component {
  setInfo(info) {
    this.props.setCommitteeData(info, BUS_OWN);
  }

  updateValues = (value, i, key) => {
    // console.log(i, "--------------------", value);
    let info = this.props.data;
    info.businessesList[i][key] = value;
    this.setInfo(info);
  };

  generateFieldData = (info) => {
    const html = [];
    const isSelComt = this.props.isSelComt;
    if (Array.isArray(info)) {
      info.forEach((j, i) => {
        html.push(
          <Col sm={12}>
            <label>Name of Business</label>:
          </Col>,
          <Col sm={12}>
            <span>{j.businessName}</span>
          </Col>,
          <Col sm={12}>
            <label>Asset Value</label>:
          </Col>,
          <Col sm={12}>
            <span>{toCurrency(j.propertyValue)}</span>
            {isSelComt && (
              <Input
                maxLength="10"
                className="inline-input"
                value={j.newPropertyValue}
                disabled={this.props.disableSelComt}
                onChange={(e) => {
                  let value = e.target.value;
                  if(isNaN(value)) {
                    value='';
                  } else if(value) {
                    value = Number(value);
                  }
                  if (value > 9999999999) {
                    value = value.toString().slice(0, 10);
                  }
                  this.updateValues(value, i, "newPropertyValue");
                }}
              />
            )}
          </Col>,
          <Col sm={12}>
            <label>Annual Income</label>:
          </Col>,
          <Col sm={12}>
            <span>{toCurrency(j.annualIncome)}</span>
            {isSelComt && (
              <Input
                maxLength="8"
                className="inline-input"
                value={j.newAnnualIncome}
                disabled={this.props.disableSelComt}
                onChange={(e) => {
                  let value = e.target.value;
                  if(isNaN(value)) {
                    value='';
                  } else if(value) {
                    value = Number(value);
                  }
                  if (value > 99999999) {
                    value = value.toString().slice(0, 8);
                  }
                  this.updateValues(value, i, "newAnnualIncome");
                }}
              />
            )}
          </Col>,
          <Col sm={12}>
            <label>Remarks</label>:
          </Col>,
          <Col sm={12}>
            <span>{j.remarks}</span>
          </Col>
        );
      });
    }
    return html;
  };
  render() {
    let info = this.props.data;
    if(!info) {
      return (
        <ViewSurveyCard title="Business Owned" {...this.props}>
          <Empty />
        </ViewSurveyCard>
      );
    }
    return (
      <div>
        <ViewSurveyCard title="Business Owned" {...this.props}>
          {this.generateFieldData(info.businessesList)}
        </ViewSurveyCard>
      </div>
    );
  }
}

export default BusinessView;
